export default __webpack_public_path__ + "static/media/dados-figura2.23b3a204.png";